import type { Signal } from '@preact/signals-react';
import type {
  ContinuousScrollerFilter,
  ContinuousScrollerSort,
} from '../../continuous-scroller/continuous-scroller-types';
import type { JsonData } from '../../generic-types';
import type { DataGridColumnSettings } from '../data-grid-settings.interface';
import { Data } from './data';
import { Filters } from './filters';
import { SortedFields } from './sorted-fields';

export class Api {
  private readonly _filters: Filters;
  private readonly _data: Data;
  private readonly _sortedFields: SortedFields;

  constructor(
    resetView: () => void,
    fieldFilters: Signal<Array<ContinuousScrollerFilter>>,
    fieldSorts: Signal<Array<ContinuousScrollerSort>>,
    columns: Signal<Array<DataGridColumnSettings>>,
    staticData: Signal<JsonData>,
    selectedRows: Signal<JsonData>,
    highlightedRows: Signal<JsonData>
  ) {
    this._filters = new Filters(fieldFilters);
    this._data = new Data(resetView, columns, staticData, selectedRows, highlightedRows);
    this._sortedFields = new SortedFields(fieldSorts);
  }

  get filters() {
    return this._filters;
  }

  get data() {
    return this._data;
  }

  get sortedFields() {
    return this._sortedFields;
  }
}
